const LINE_SX = { display: "block", fontSize: "0.75rem" } as const;

export default LINE_SX;
